import React from "react";
import { StudentChart, SideMenu, BackHeader } from "./../../components";
import { useNavigate } from "react-router-dom";
let RatingAnalytics = (props) => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <div className="analytics-graph-main">
          <div className="graph-filter-main">
            <p className="analytics-graph-heading"></p>
            <div className="analytics-graph-filter-header">
              <p className="analytics-graph-header-date">Jan-2022</p>
              <select className="analytics-graph-filter-dropdown">
                <option value="Monthly">Monthly</option>
                <option value="Weekely">Weekely</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>
          </div>
          <StudentChart />
        </div>
      </div>
    </SideMenu>
  );
};
export default RatingAnalytics;
